import { inject, Injectable } from '@angular/core';

import { SystemErrorService } from '@tdwb/core';
import type { HookResult, Transition, TransitionService } from '@uirouter/angular';

/**
 * This Router service is responsible for closing the system error message
 * when we are exiting from the route. This is to prevent the requests that fail
 * while resolving data for a transition have the error panel close before being visible
 */
@Injectable({
  providedIn: 'root'
})
export class RouterSystemErrorService {
  private readonly systemErrorService = inject(SystemErrorService, { optional: true });

  static initHooks(transitionService: TransitionService): void {
    transitionService.onExit(
      { to: '**', from: '**' }, (transition: Transition): HookResult | void => {
        const routerStatusService: RouterSystemErrorService = transition.injector().get(RouterSystemErrorService);
        routerStatusService.handlePageTransition();
      });
  }

  private handlePageTransition(): void {
    if (this.systemErrorService !== undefined && this.systemErrorService !== null) {
      this.systemErrorService.close();
    }
  }
}
